import {ILinkSlideProps} from "~/components/ui"

//images
const slide1 = `${process.env.GATSBY_IMAGES}expertise/sliderLinksImage/slide1.png`
const slide2 = `${process.env.GATSBY_IMAGES}expertise/sliderLinksImage/slide2.png`
const slide3 = `${process.env.GATSBY_IMAGES}expertise/sliderLinksImage/slide3.png`
const slide4 = `${process.env.GATSBY_IMAGES}expertise/sliderLinksImage/slide4.png`
const slide5 = `${process.env.GATSBY_IMAGES}expertise/sliderLinksImage/slide5.png`
const slide1Webp = `${process.env.GATSBY_IMAGES}expertise/sliderLinksImage/slide1.webp`
const slide2Webp = `${process.env.GATSBY_IMAGES}expertise/sliderLinksImage/slide2.webp`
const slide3Webp = `${process.env.GATSBY_IMAGES}expertise/sliderLinksImage/slide3.webp`
const slide4Webp = `${process.env.GATSBY_IMAGES}expertise/sliderLinksImage/slide4.webp`
const slide5Webp = `${process.env.GATSBY_IMAGES}expertise/sliderLinksImage/slide5.webp`

export const sliderContent: (ILinkSlideProps & {key: string})[] = [
  {
    key: 'slide1',
    title: 'First – New Patient Evaluation',
    imagePath: slide1,
    imagePathWebP: slide1Webp,
    linkName: 'Next – Receive Case',
    text: 'First, send your patient’s impressions to our team and upload your patient’s photos to the doctor portal. We then estimate a treatment plan based on the movement required for the desired outcome. \n'
  },
  {
    key: 'slide2',
    title: 'Next – Receive Case',
    imagePath: slide2,
    imagePathWebP: slide2Webp,
    linkName:'Then – Target the Perfect Fit',
    text: 'Next, we take your patient\'s impressions and bite registration along with the Rx. IMPORTANT: We recommend a Poly Vinyl Silicone (PVS) impression so we can pour a high–quality, Dynamic Physical Model (DPM). This helps ensure each aligner is the perfect fit, every time.'
  },
  {
    key: 'slide3',
    title: 'Then – Target the Perfect Fit',
    imagePath: slide3,
    imagePathWebP: slide3Webp,
    linkName:'Later – Mark Case',
    text: 'We identify which teeth are targeted for movement using a combination of highly effective and precise techniques. Using die epoxy material for the model and a layered anchoring system, adjacent teeth will remain stationary while the targeted teeth become aligned. '
  },
  {
    key: 'slide4',
    title: 'Later – Mark Case',
    imagePath: slide4,
    imagePathWebP: slide4Webp,
    linkName:'Finally – Packaging, Shipping and Storage',
    text: 'An Orthosnap technician marks the direction of the movement on the DPM for each tooth using laser–guided pinholes and determines if the impression is of sufficient quality for the type of movement required.'
  },
  {
    key: 'slide5',
    title: 'Finally – Packaging, Shipping and Storage',
    imagePath: slide5,
    imagePathWebP: slide5Webp,
    text: 'Once the aligners are produced and checked, they are packaged, labeled, and shipped. Each case model is stored with the doctor until the case treatment is complete.'
  }
];
